import * as Clipboard from 'expo-clipboard'
import * as Linking from 'expo-linking'
import Toast from 'react-native-root-toast'
import { MessageType } from './message-type'
import { Env } from '../env'

/**
 * Copies an invitation link to the clipboard (deep link format)
 * @param code - The invitation code
 * @param successMessage - Optional success message to display
 */
export async function copyInvitationLink(
  code: string,
  successMessage?: string
): Promise<void> {
  const invitationUrl = Linking.createURL(`invitation/${code}`)
  await Clipboard.setStringAsync(invitationUrl)

  if (successMessage) {
    Toast.show(successMessage, MessageType.info)
  }
}

/**
 * Copies an invitation web link to the clipboard (full web URL)
 * @param code - The invitation code
 * @param successMessage - Optional success message to display
 */
export async function copyInvitationWebLink(
  code: string,
  successMessage?: string
): Promise<void> {
  const invitationUrl = `${Env.BASE_URL}/invitation/${code}`
  await Clipboard.setStringAsync(invitationUrl)

  if (successMessage) {
    Toast.show(successMessage, MessageType.info)
  }
}

/**
 * Generates the invitation deep link URL for a given code
 * @param code - The invitation code
 * @returns The invitation deep link URL
 */
export function getInvitationUrl(code: string): string {
  return Linking.createURL(`invitation/${code}`)
}

/**
 * Generates the invitation web URL for a given code
 * @param code - The invitation code
 * @returns The full web invitation URL
 */
export function getInvitationWebUrl(code: string): string {
  return `${Env.BASE_URL}/invitation/${code}`
}
